import { createContext, useContext, useEffect } from 'react';
import { TreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import { FunctionComponentWithChildren } from 'src/utils/types';
import { ExperimentProps, UseExperimentResult } from 'src/services/experiments/types';
import { ActiveSplitExperiment } from 'src/services/experiments/client/ongoingExperiments';
import { initExperiments } from 'src/services/experiments/utils/initExperiments';
/**
 * This is the file that provides the server side values
 */
// eslint-disable-next-line no-restricted-syntax
import { getExperiment } from 'src/services/experiments/utils/getExperiment';
export const ExperimentContext = createContext<ExperimentProps>({
    experiments: {},
    resolvedTrackers: [],
    requestedExperiments: [],
    experimentClientInitialized: false,
});

export const useExperiments = (): UseExperimentResult => {
    const {
        experimentClientInitialized: clientInitialized,
        requestedExperiments,
        experiments,
    } = useContext(ExperimentContext);

    return {
        clientInitialized,
        requestedExperiments,
        experiments: Object.entries(experiments).reduce<Record<ActiveSplitExperiment, TreatmentWithConfig | null>>(
            (acc, [experimentName, experiment]) => ({
                ...acc,
                [experimentName]: {
                    ...experiment,
                    ...getExperiment(experimentName as ActiveSplitExperiment, experiments),
                },
            }),
            {} as Record<ActiveSplitExperiment, TreatmentWithConfig | null>
        ),
    };
};

export const ExperimentProvider: FunctionComponentWithChildren<ExperimentProps> = ({ children, ...data }) => {
    const { experiments, requestedExperiments } = data;
    useEffect(() => {
        initExperiments(experiments);
    }, [experiments, requestedExperiments]);

    return <ExperimentContext.Provider value={data}>{children}</ExperimentContext.Provider>;
};
